
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Ertigaonrentinpune() {



    const cardData =
    {
        keyword: 'Ertiga On Rent in Pune',
        heading: 'Platinum24 Cabs: Ertiga On Rent in Pune',
        headingDescription: ' Platinum24 Cabs provides reliable Ertiga on Rent in Pune, perfect for small families, corporate travelers, and groups seeking comfort with affordability. The Ertiga offers spacious seating, modern interiors, excellent mileage, and ample luggage space, making it ideal for both local and outstation travel. Whether it’s an airport transfer, weekend getaway, or long-distance trip, our well-maintained AC Ertiga cabs with professional chauffeurs ensure a safe, comfortable, and timely journey. With flexible rental packages and transparent pricing, Platinum24 Cabs guarantees a hassle-free travel experience in and around Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort palace. Once the seat of the Maratha Empire, its massive gates, fountains, and ruins narrate tales of grandeur. Though destroyed by fire in 1828, it still draws thousands of visitors. The evening light-and-sound show recreates the legacy of Bajirao and Mastani. Tourists love exploring its historic courtyards and gardens. Shaniwar Wada is Pune’s proud heritage symbol."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum showcasing Gandhi’s belongings and photographs. The Italian arches and sprawling lawns add architectural beauty. It is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historical and inspirational landmark."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought bravely for Chhatrapati Shivaji Maharaj. The fort offers trekking trails, temples, and panoramic views of the Sahyadris. In monsoon, mist and waterfalls make the climb enchanting. Visitors also enjoy local delicacies like pithla-bhakri at the fort. It is a blend of adventure and history. Sinhagad is Pune’s must-visit trekking and heritage spot."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the center of grand festivities with thousands of devotees. The temple is also known for its charitable activities. It is a spiritual and cultural icon of the city. Dagdusheth Ganpati is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The temple features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city center, it offers peace and spirituality. Its architecture reflects ancient Indian craftsmanship. Evening chants create a mystical aura. Pataleshwar is Pune’s hidden spiritual gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, sculptures, musical instruments, and everyday antiques. The recreated Mastani Mahal is a highlight. It is an educational and fascinating spot for history enthusiasts. The museum preserves Indian traditions across centuries. It is Pune’s cultural treasure house."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city. At its summit stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, it also houses museums and smaller shrines. Climbing 103 steps to the top is both devotional and adventurous. Sunrise and sunset views here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global center for wellness and spirituality. Spread across lush gardens, it attracts seekers worldwide. It offers meditation, yoga sessions, and personal growth workshops. The ashram’s Zen gardens and serene meditation halls provide tranquility. It is ideal for rejuvenation and mindfulness. Osho Ashram is Pune’s international hub of peace and harmony."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns make it a peaceful retreat. Families enjoy strolls, photography, and picnics here. The garden represents Indo-Japanese cultural friendship. Seasonal flowers enhance its beauty year-round. Pu La Deshpande Garden is Pune’s green oasis of calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite weekend destination near Pune. It supplies water to the city while offering picturesque landscapes. During monsoon, the overflowing dam becomes a spectacular sight. Street food stalls selling corn and tea make it lively. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway."
  }
],



       "services": [
    {
      "name": "Ertiga Rental Pune",
      "description": "Reliable and comfortable Ertiga rental service in Pune ideal for small group travel, airport transfers, and outstation trips. Our Ertiga fleet features spacious seating for 6–7 passengers, ample boot space for luggage, and fuel-efficient performance. With well-maintained vehicles and flexible rental durations, we cater to both short city drives and long-distance journeys. Whether you’re planning a family vacation, a business tour, or a weekend getaway, our Ertiga rentals offer affordability without compromising comfort."
    },
    {
      "name": "Ertiga On Rent Pune",
      "description": "Get an Ertiga on rent in Pune for daily, weekly, or monthly usage at competitive rates. Ideal for groups, the Ertiga provides a blend of utility and elegance with its plush interiors, powerful AC, and smooth ride quality. We offer both chauffeur-driven and self-drive rental options based on your preference. Each rental comes with comprehensive insurance, road assistance, and a trained support team to ensure peace of mind throughout your trip."
    },
    {
      "name": "Rent Ertiga Car Pune",
      "description": "Rent an Ertiga car in Pune for any occasion—be it a local trip, business meeting, or a weekend escape. Our booking process is seamless, with real-time availability, quick confirmations, and doorstep delivery of the vehicle. The Ertiga offers flexible 6-seater and 7-seater configurations, ensuring comfort even during long hours of travel. We prioritize safety with GPS-enabled tracking, sanitized vehicles, and verified drivers when you opt for chauffeur service."
    },
    {
      "name": "Pune Ertiga Car Hire",
      "description": "Affordable and flexible Ertiga car hire service in Pune for personal and professional use. Perfect for families, executives, or tour groups, the Ertiga offers impressive mileage, spacious interiors, and advanced safety features. Choose from hourly, full-day, or multi-day hire packages with easy booking via phone or online. Our trained drivers ensure a punctual and hassle-free travel experience for intra-city and inter-city rides."
    },
    {
      "name": "Affordable Ertiga Rental Pune",
      "description": "Experience budget-friendly travel with our affordable Ertiga rentals in Pune. Enjoy transparent pricing with no hidden costs, along with complimentary services like doorstep pickup, sanitized vehicles, and round-the-clock customer assistance. Whether for airport transfers, outstation travel, or daily city commutes, our Ertiga rental packages are designed to provide maximum value without compromising on comfort or quality."
    },
    {
      "name": "Ertiga Taxi Service Pune",
      "description": "Professional Ertiga taxi service in Pune for individuals, families, and corporate clients. Our well-equipped Ertiga taxis come with experienced chauffeurs, modern amenities, and ample legroom for a comfortable journey. Ideal for point-to-point transfers, full-day rentals, or intercity travel, the Ertiga is a perfect blend of economy and space. Choose our service for on-time pickup, courteous drivers, and 24/7 support."
    },
    {
      "name": "Ertiga Car Booking Pune",
      "description": "Book an Ertiga car in Pune instantly through our online or phone-based system. Choose from a wide range of rental durations, from hourly to long-term leases. Our vehicles are regularly serviced and come with GPS, powerful AC, and clean interiors. Whether for a quick trip or a multi-day journey, booking an Ertiga with us ensures convenience, reliability, and complete satisfaction every time."
    },
    {
      "name": "Pune Ertiga with Driver",
      "description": "Hire an Ertiga in Pune with a professional driver for a stress-free travel experience. Our chauffeurs are background-verified, well-trained, and familiar with city routes as well as intercity destinations. Enjoy a smooth ride with features like dual AC vents, comfortable seating, and a clean cabin. Ideal for tourists, business professionals, and family travelers who want comfort without the responsibility of driving."
    },
    {
      "name": "Ertiga Car Rental Deals Pune",
      "description": "Get exciting deals and seasonal offers on Ertiga car rentals in Pune. We provide discounted rates for long-term bookings, corporate clients, and early-bird reservations. Enjoy perks such as free kilometers, included fuel, or free driver allowance based on the deal selected. Stay updated with our latest offers to get premium service at budget-friendly prices with no compromise on quality."
    },
    {
      "name": "Ertiga Hire for Tours Pune",
      "description": "Perfect for tours and excursions, our Ertiga hire service in Pune is suitable for family trips, pilgrimages, and sightseeing. The Ertiga offers a smooth and powerful ride with enhanced fuel efficiency and storage space. Customize your itinerary and travel comfortably with our flexible plans, knowledgeable drivers, and safety-focused service for all your group travel needs within and beyond Pune."
    },
    {
      "name": "Ertiga Rental for Airport Transfers Pune",
      "description": "Reliable Ertiga rentals for airport transfers between Pune city and Pune or Mumbai airports. Enjoy timely pickups, smooth travel, and spacious interiors perfect for handling both passengers and their luggage. Our drivers track your flight schedule to adjust pickups accordingly. Whether arriving or departing, you can count on us for a hassle-free airport commute in a clean and comfortable Ertiga."
    },
    {
      "name": "Ertiga Rental for Corporate Use Pune",
      "description": "Dedicated Ertiga rental service for corporate clients in Pune with custom billing, fixed routes, employee pickup/drop options, and flexible contracts. We ensure punctuality, professional drivers, and comfortable travel for business executives or teams. Monthly corporate plans and premium support are available to meet enterprise-level transport requirements with efficiency and professionalism."
    },
    {
      "name": "Ertiga Rental for Family Trips Pune",
      "description": "Comfortable and convenient Ertiga rentals in Pune designed for family trips and weekend getaways. The Ertiga's spacious seating and modern amenities ensure everyone, including kids and elderly passengers, travels comfortably. Book for a day or a week with flexible plans, and let our expert drivers handle the road while you focus on creating memories with your loved ones."
    },
    {
      "name": "Ertiga Rental with AC Pune",
      "description": "All our Ertiga rental cars in Pune come with powerful air conditioning to ensure a cool and relaxing journey regardless of the weather. Perfect for both city commutes and long-distance travel, our AC-enabled Ertigas offer dual-zone cooling, adjustable vents, and a fresh, clean cabin environment. Stay cool and comfortable as you travel across Pune or head outstation."
    },
    {
      "name": "Pune Ertiga Self Drive Rental",
      "description": "Explore Pune at your own pace with our Ertiga self-drive rental service. Ideal for those who prefer privacy and independence, our self-drive Ertigas are available for hourly, daily, or weekly rentals. The vehicles are well-maintained, insured, and equipped with the latest features. Enjoy a flexible and secure driving experience with 24/7 roadside assistance and easy documentation."
    }
  ],
  "tableData": [
    ["Ertiga Rental Pune", "Ertiga On Rent Pune"],
    ["Rent Ertiga Car Pune", "Pune Ertiga Car Hire"],
    ["Affordable Ertiga Rental Pune", "Ertiga Taxi Service Pune"],
    ["Ertiga Car Booking Pune", "Pune Ertiga with Driver"],
    ["Ertiga Car Rental Deals Pune", "Ertiga Hire for Tours Pune"],
    ["Ertiga Rental for Airport Transfers Pune", "Ertiga Rental for Corporate Use Pune"],
    ["Ertiga Rental for Family Trips Pune", "Ertiga Rental with AC Pune"],
    ["Pune Ertiga Self Drive Rental", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Ertiga on Rent in Pune for Comfortable Group Travel",
      "WhyChoosedescription": "Platinum24 Cabs offers well-maintained Ertiga vehicles on rent, ideal for family outings and small group trips in Pune."
    },
    {
      "WhyChooseheading": "Spacious 7-Seater with Ample Legroom and Luggage Space",
      "WhyChoosedescription": "Travel comfortably with enough space for passengers and their belongings."
    },
    {
      "WhyChooseheading": "Perfect for City Rides, Airport Transfers, and Outstation Trips",
      "WhyChoosedescription": "Whether it’s a short city drive or a long-distance journey, our Ertiga rental service has you covered."
    },
    {
      "WhyChooseheading": "Fuel-Efficient and Well-Maintained Vehicles",
      "WhyChoosedescription": "Enjoy smooth rides in our clean, regularly serviced, and fuel-efficient Ertiga cars."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Knowledge",
      "WhyChoosedescription": "Our professional drivers ensure safe, timely, and hassle-free travel within Pune and beyond."
    },
    {
      "WhyChooseheading": "Clean and Sanitized Cars for Your Safety",
      "WhyChoosedescription": "All vehicles undergo thorough cleaning and sanitization before every trip."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Get upfront pricing that includes fuel, tolls, and driver allowances for stress-free booking."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Hourly, Daily, or Long-Term Rentals",
      "WhyChoosedescription": "Choose the rental plan that best suits your travel needs and schedule."
    }
  ]






















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Ertiga on rent in Pune?',
        answer: 'Yes, Platinum24 Cabs provides Ertiga car rentals in Pune for comfortable and spacious travel.',
    },
    {
        question: 'How can I book an Ertiga on rent in Pune with Platinum24 Cabs?',
        answer: 'You can easily book an Ertiga through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What is the seating capacity of the Ertiga available for rent?',
        answer: 'The Ertiga typically seats 7 passengers comfortably, making it ideal for families and small groups.',
    },
    {
        question: 'Are the Ertiga vehicles well-maintained and clean?',
        answer: 'Yes, all Ertiga cars are regularly serviced, cleaned, and sanitized for a safe and pleasant journey.',
    },
    {
        question: 'Can I hire an Ertiga for local Pune travel as well as outstation trips?',
        answer: 'Absolutely! We offer rentals for both local travel within Pune and outstation trips to nearby destinations.',
    },
    {
        question: 'What rental packages are available for Ertiga in Pune?',
        answer: 'We provide flexible hourly, daily, and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Do Ertiga rentals come with a driver?',
        answer: 'Yes, all rentals include professional, experienced drivers to ensure a safe and hassle-free trip.',
    },
    {
        question: 'Can I customize pickup and drop-off locations when renting an Ertiga?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points for a convenient travel experience.',
    },
    {
        question: 'What safety measures are followed for Ertiga rentals?',
        answer: 'Our vehicles are regularly sanitized, and drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is corporate Ertiga rental available in Pune?',
        answer: 'Yes, Platinum24 Cabs offers customized corporate rental solutions for Ertiga with priority support and flexible billing.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohan Patil',
        feedback: 'Renting an Ertiga from Platinum24 Cabs was a great experience. The car was spacious and the driver professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Shruti Shah',
        feedback: 'The Ertiga rental service was smooth and hassle-free. Highly recommend Platinum24 Cabs for reliable car rentals.',
        rating: 5,
    },
];



































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const ertigaOnRentPuneSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Pune",
  "image": "https://www.platinum24cab.com/assets/images/ertiga-rental-pune.jpg",
  "description": "Affordable Ertiga car rental in Pune for airport transfers, corporate use, family trips, and tours. Rent an Ertiga with driver or self-drive at Platinum24 Cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/ertiga-on-rent-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Ertiga On Rent in Pune | Affordable Ertiga Car Rental | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Affordable Ertiga car rental in Pune for airport transfers, corporate use, family trips, and tours. Rent an Ertiga with driver or self-drive at Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="Ertiga Rental Pune, Ertiga On Rent Pune, Rent Ertiga Car Pune, Pune Ertiga Car Hire, Affordable Ertiga Rental Pune, Ertiga Taxi Service Pune, Ertiga Car Booking Pune, Pune Ertiga with Driver, Ertiga Car Rental Deals Pune, Ertiga Hire for Tours Pune, Ertiga Rental for Airport Transfers Pune, Ertiga Rental for Corporate Use Pune, Ertiga Rental for Family Trips Pune, Ertiga Rental with AC Pune, Pune Ertiga Self Drive Rental"
  />
  <script type="application/ld+json">
    {JSON.stringify(ertigaOnRentPuneSchema)}
  </script>
</Helmet>



            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/23.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Ertigaonrentinpune;